export default __webpack_public_path__ + "static/media/Zampar.1527b9f2.mp3";